module.exports = __webpack_public_path__ + "static/img/05-moreUsers.732d630.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter/05-moreUsers.jpg
// module id = AMyg
// module chunks = 1